// import myImage from './path_to_your_image.png';
// <img src={myImage} alt="My Image" />

import audiovideo1 from './pics/audio video/audiovideo1.jpeg';
import audiovideo2 from './pics/audio video/audiovideo2.jpeg';
import audiovideo3 from './pics/audio video/audiovideo3.jpeg';
import audiovideo4 from './pics/audio video/audiovideo4.jpeg';
import audiovideo5 from './pics/audio video/audiovideo5.jpeg';
import avcon1 from './pics/av conferencing replacement/avcon1.jpeg';
import avcon2 from './pics/av conferencing replacement/avcon2.jpeg';
import avcon3 from './pics/av conferencing replacement/avcon3.jpeg';
import avcon4 from './pics/av conferencing replacement/avcon4.jpeg';
import avcon5 from './pics/av conferencing replacement/avcon5.jpeg'; 
import avcon6 from './pics/av conferencing replacement/avcon6.jpeg';
import avcon7 from './pics/av conferencing replacement/avcon7.jpeg';
import avcon8 from './pics/av conferencing replacement/avcon8.jpeg';
import bm1 from './pics/broadcom migration/bm1.jpeg';
import bm2 from './pics/broadcom migration/bm2.jpeg';
import bm3 from './pics/broadcom migration/bm3.jpeg'; 
import bm4 from './pics/broadcom migration/bm4.jpeg';
import bm5 from './pics/broadcom migration/bm5.jpeg';
import bm6 from './pics/broadcom migration/bm6.jpeg';
import bm7 from './pics/broadcom migration/bm7.jpeg';
import bm8 from './pics/broadcom migration/bm8.jpeg';
import bm9 from './pics/broadcom migration/bm9.jpeg';
import bm10 from './pics/broadcom migration/bm10.jpeg';
import bm11 from './pics/broadcom migration/bm11.jpeg';
import bm12 from './pics/broadcom migration/bm12.jpeg';
import bm13 from './pics/broadcom migration/bm13.jpeg';   
import bm14 from './pics/broadcom migration/bm14.jpeg';
import bm15 from './pics/broadcom migration/bm15.jpeg';
import bm16 from './pics/broadcom migration/bm16.jpeg';
import bm17 from './pics/broadcom migration/bm17.jpeg';
import bm18 from './pics/broadcom migration/bm18.jpeg';
import or1 from './pics/office recabling/or1.jpeg';
import or2 from './pics/office recabling/or2.jpeg';
import or3 from './pics/office recabling/or3.jpeg';
import or4 from './pics/office recabling/or4.jpeg';
import or5 from './pics/office recabling/or5.jpeg';
import or6 from './pics/office recabling/or6.jpeg';
import or7 from './pics/office recabling/or7.jpeg';
import or8 from './pics/office recabling/or8.jpeg';
import or9 from './pics/office recabling/or9.jpeg';
import or10 from './pics/office recabling/or10.jpeg';
import or11 from './pics/office recabling/or11.jpeg';
import or12 from './pics/office recabling/or12.jpeg';
import or13 from './pics/office recabling/or13.jpeg';
import or14 from './pics/office recabling/or14.jpeg';
import or15 from './pics/office recabling/or15.jpeg';
import or16 from './pics/office recabling/or16.jpeg';
import or17 from './pics/office recabling/or17.jpeg';
import or18 from './pics/office recabling/or18.jpeg';
import sf1 from './pics/switch and firewall/sf1.jpeg';
import sf2 from './pics/switch and firewall/sf2.jpeg';
import sf3 from './pics/switch and firewall/sf3.jpeg';
import sf4 from './pics/switch and firewall/sf4.jpeg';
import sf5 from './pics/switch and firewall/sf5.jpeg';
import wh1 from './pics/warehousing/wh1.jpeg';
import wh2 from './pics/warehousing/wh2.jpeg';
import wh3 from './pics/warehousing/wh3.jpeg';
import wh4 from './pics/warehousing/wh4.jpeg';
import wh5 from './pics/warehousing/wh5.jpeg';

// Collect all images per service slug (Vite and Webpack supported)
const collectLocalImages = () => {
  const bySlug = {};

  const push = (slug, url) => {
    if (!slug || !url) return;
    bySlug[slug] = bySlug[slug] || [];
    // avoid duplicates
    if (!bySlug[slug].includes(url)) bySlug[slug].push(url);
  };

  const slugFromPath = (p) => {
    if (!p) return null;
    const path = p.replaceAll('\\', '/');
    // match either /services/<slug>/ or /pics/<slug>/
    const m = path.match(/\/services\/([^/]+)\//) || path.match(/\/pics\/([^/]+)\//);
    return m ? m[1] : null;
  };

  const hasViteGlob =
    typeof import.meta !== 'undefined' &&
    import.meta &&
    typeof import.meta.glob === 'function';

  if (hasViteGlob) {
    // search both candidate folders
    const modules = {
      ...import.meta.glob('../assets/services/**/*.{png,jpg,jpeg,webp}', { eager: true }),
      ...import.meta.glob('./pics/**/*.{png,jpg,jpeg,webp}', { eager: true })
    };
    Object.entries(modules).forEach(([path, mod]) => {
      const slug = slugFromPath(path);
      const url = mod && mod.default ? mod.default : (typeof mod === 'string' ? mod : null);
      push(slug, url);
    });
  } else {
    // Webpack / CRA fallback
    try {
      const ctxA = require.context('../assets/services', true, /\.(png|jpe?g|webp)$/);
      ctxA.keys().forEach((key) => {
        const full = `../assets/services/${key.replace('./', '')}`;
        const slug = slugFromPath(full);
        const url = ctxA(key);
        push(slug, url);
      });
    } catch (e) { /* no assets/services */ }

    try {
      const ctxB = require.context('./pics', true, /\.(png|jpe?g|webp)$/);
      ctxB.keys().forEach((key) => {
        const full = `./pics/${key.replace('./', '')}`;
        const slug = slugFromPath(full);
        const url = ctxB(key);
        push(slug, url);
      });
    } catch (e) { /* no data/pics */ }
  }

  // sort stable (optional)
  Object.keys(bySlug).forEach((slug) => {
    bySlug[slug].sort();
  });

  return bySlug;
};

const autoImagesBySlug = collectLocalImages();

const manualImagesBySlug = {
  'audio-video-solutions': [audiovideo1, audiovideo2, audiovideo3, audiovideo4, audiovideo5],
  'conferencing-solutions': [avcon1, avcon2, avcon3, avcon4, avcon5, avcon6, avcon7, avcon8],
  'broadcom-migration': [
    bm1, bm2, bm3, bm4, bm5, bm6, bm7, bm8, bm9, bm10, bm11, bm12, bm13, bm14, bm15, bm16, bm17, bm18
  ],
  'office-recabling': [
    or1, or2, or3, or4, or5, or6, or7, or8, or9, or10, or11, or12, or13, or14, or15, or16, or17, or18
  ],
  'switch-firewall': [sf1, sf2, sf3, sf4, sf5],
  'it-equipment-warehousing': [wh1, wh2, wh3, wh4, wh5],
};

const imagesBySlug = { ...manualImagesBySlug, ...autoImagesBySlug };

export const services = [
  {
    slug: 'broadcom-migration',
    title: 'Data Center Migration',
    summary:
      'End-to-end data center migration including planning, compatibility analysis, staged rollout, configuration mapping, validation, and optimization.',
    description:
      'We deliver risk-managed data center migrations using proven playbooks. Our team handles discovery, impact analysis, policy/config mapping, lab validation, phased rollout, and post-migration tuning to ensure zero data loss and minimal downtime.',
    accent: 'from-blue-600 to-cyan-500',
    timeline: '4-8 weeks',
    complexity: 'Enterprise',
    stats: { projects: 120, satisfaction: 98, duration: 'Avg. 6 weeks' },
    features: [
      'Discovery & assessment',
      'Compatibility analysis',
      'Policy/config mapping',
      'Lab validation & UAT',
      'Phased rollout plan',
      'Cutover & rollback design',
      'Monitoring & optimization',
      'Knowledge transfer'
    ],
    deliverables: [
      'Migration blueprint',
      'Compatibility report',
      'Configuration documents',
      'Risk register',
      'Testing plan & results',
      'Runbook & rollback plan',
      'Post-migration report',
      'Training materials'
    ],
    faqs: [
      { q: 'Will there be downtime during migration?', a: 'We design phased rollouts and maintenance windows to avoid business disruption and ensure rollback is available.' },
      { q: 'Do you support complex multi-site environments?', a: 'Yes. We regularly handle multi-site, multi-vendor environments with strict change control.' }
    ],
    caseStudy: {
      client: 'Global FinServ',
      result: 'Cutover in 6 weeks with zero P1 incidents',
      metrics: ['98% satisfaction', '0 critical defects', '15% performance gain']
    }
  },
  {
    slug: 'office-recabling',
    title: 'Office Recabling',
    summary:
      'Structured cabling (Cat6/Cat6a/Cat7) with design, installation, labeling, testing and certification for reliable connectivity.',
    description:
      'Professional structured cabling for new builds, expansions, and refurbishments. We deliver clean runs, cable management, and certified terminations that pass Fluke tests.',
    accent: 'from-green-600 to-emerald-500',
    timeline: '2-6 weeks',
    complexity: 'Medium',
    stats: { projects: 180, satisfaction: 99, duration: 'Avg. 3 weeks' },
    features: [
      'On-site survey & design',
      'Cable trays & pathways',
      'Professional labeling',
      'Patch panels & termination',
      'Fluke testing & certification',
      'Rack dressing & management',
      'As-built documentation',
      'Handover & training'
    ],
    deliverables: ['Network diagram', 'Cable schedule', 'Test reports', 'As-built documentation'],
    faqs: [
      { q: 'Do you work off-hours?', a: 'Yes, we accommodate night and weekend work to minimize disruption.' },
      { q: 'What testing do you provide?', a: 'We provide Fluke test certification for every run and deliver reports.' }
    ],
    caseStudy: {
      client: 'MedCare HQ',
      result: '200+ drops installed, certified, and labeled in 2.5 weeks',
      metrics: ['0 rework', '100% certified', 'Ahead of schedule']
    }
  },
  {
    slug: 'switch-firewall',
    title: 'Switch & Firewall',
    summary:
      'Supply, install, and configure enterprise switches and firewalls: VLANs, ACLs, HA, VPNs, segmentation, and hardening.',
    description:
      'From design to deployment, we implement resilient switching and robust firewall policies. We deliver secure, segmented networks aligned to best practices.',
    accent: 'from-indigo-600 to-violet-500',
    timeline: '3-5 weeks',
    complexity: 'High',
    stats: { projects: 95, satisfaction: 97, duration: 'Avg. 4 weeks' },
    features: [
      'Network architecture & HLD/LLD',
      'VLAN & QoS configuration',
      'ACLs & zone policies',
      'HA pairs & state sync',
      'Site-to-site & remote VPN',
      'Zero-trust segmentation',
      'Hardening & compliance',
      'Monitoring & runbooks'
    ],
    deliverables: ['HLD/LLD', 'Security policy set', 'Config backups', 'Operational runbook'],
    faqs: [
      { q: 'Can you integrate with existing vendors?', a: 'Yes. We work across major vendors and integrate gradually with rollback safety.' },
      { q: 'Do you provide documentation and training?', a: 'All projects include runbooks and optional admin training sessions.' }
    ],
    caseStudy: {
      client: 'Retail Group',
      result: 'Reduced lateral movement risk by 70% with segmentation',
      metrics: ['HA uptime 99.99%', 'PCI-ready policies', 'Rapid VPN rollout']
    }
  },
  {
    slug: 'audio-video-solutions',
    title: 'Audio & Video Solutions',
    summary:
      'AV installations for meeting rooms, boardrooms, and auditoriums. Speakers, mixers, displays, calibration, and control.',
    description:
      'We deliver immersive AV experiences. From design and equipment selection to installation, tuning, and control integration.',
    accent: 'from-yellow-500 to-orange-400',
    timeline: '1-4 weeks',
    complexity: 'Medium',
    stats: { projects: 140, satisfaction: 99, duration: 'Avg. 2 weeks' },
    features: [
      'Room assessment & design',
      'Equipment supply',
      'Professional installation',
      'Audio calibration & tuning',
      'Control integration',
      'User training & guides',
      'Remote management',
      'Warranty handling'
    ],
    deliverables: ['Room drawings', 'Equipment list', 'Calibration report', 'User guides'],
    faqs: [
      { q: 'Do you support Zoom/Teams rooms?', a: 'Yes. We design for native Zoom/Teams experiences and hybrid conferencing.' },
      { q: 'Can you integrate with existing control systems?', a: 'We integrate with popular control platforms and AV-over-IP solutions.' }
    ],
    caseStudy: {
      client: 'Innovation Center',
      result: 'Standardized AV across 12 rooms with unified control',
      metrics: ['NPS 9.6', '30% fewer support tickets', '5-day rollout per site']
    }
  },
  {
    slug: 'it-equipment-warehousing',
    title: 'IT Equipment Warehousing',
    summary:
      'Secure warehousing and inventory management—receiving, asset tagging, climate control, and dispatch logistics.',
    description:
      'We provide secure facilities and real-time inventory tracking. From intake to asset tagging and staging, we streamline your hardware lifecycle.',
    accent: 'from-slate-600 to-gray-500',
    timeline: 'Ongoing',
    complexity: 'Low',
    stats: { projects: 60, satisfaction: 98, duration: 'SLA-backed' },
    features: [
      'Secure storage & CCTV',
      'Asset tagging & intake',
      'Inventory management',
      'Climate control',
      'Staging & burn-in',
      'Dispatch logistics',
      'Audit-ready reports',
      'Pickup & returns'
    ],
    deliverables: ['Inventory dashboard', 'Asset reports', 'Dispatch logs', 'Audit trail'],
    faqs: [
      { q: 'Do you offer insurance coverage?', a: 'Yes. We provide insured storage options and full audit trails.' },
      { q: 'Can you handle DOA returns?', a: 'We process RMA/DOA workflows and coordinate with vendors.' }
    ],
    caseStudy: {
      client: 'Edutech Corp',
      result: 'Managed 3K+ assets with real-time tracking',
      metrics: ['99.8% accuracy', 'Same-day dispatch', 'Full audit compliance']
    }
  },
  {
    slug: 'conferencing-solutions',
    title: 'Conferencing Solutions',
    summary:
      'Zoom/Teams room setups, cameras, mics, codec integration and room scheduling systems.',
    description:
      'We design modern collaboration spaces with best-in-class audio/video, intelligent cameras, and seamless calendar integrations.',
    accent: 'from-pink-600 to-rose-500',
    timeline: '1-3 weeks',
    complexity: 'Medium',
    stats: { projects: 110, satisfaction: 99, duration: 'Avg. 10 days' },
    features: [
      'Platform integration',
      'Hardware selection & setup',
      'Camera positioning',
      'Audio DSP & tuning',
      'Room scheduling displays',
      'Remote management',
      'User onboarding',
      'Support documentation'
    ],
    deliverables: ['Integration guide', 'Hardware specs', 'Room presets', 'Training sessions'],
    faqs: [
      { q: 'Do you support hybrid work models?', a: 'Yes. We optimize for in-room and remote parity with smart layouts and acoustics.' },
      { q: 'Can you standardize room kits?', a: 'We develop standard kits and documentation for rapid global rollout.' }
    ],
    caseStudy: {
      client: 'Global Pharma',
      result: 'Rolled out 25 conferencing rooms in 6 countries',
      metrics: ['NPS 9.4', 'Unified UX', 'Remote manageability']
    }
  }
].map((s) => ({
  ...s,
  images: imagesBySlug[s.slug] || []
}));

export const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);
export const getRelatedServices = (slug, limit = 3) =>
  services.filter((s) => s.slug !== slug).slice(0, limit);